import React from 'react';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";
import {renderCheckboxField} from "./inputs/CheckboxFeaild";

export class CompanyForm extends React.Component {

    render() {

        const {handleSubmit, errors, isAdmin} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                {isAdmin ?

                    <Field name="sorts"
                           label="管理番号"
                           err={errors.sorts}
                           component={renderTextField}
                           type="number"/>
                    :
                    <Field disabled
                           name="sorts"
                           label="管理番号"
                           component={renderTextField}
                           type="number"/>
                }

                {isAdmin ?

                    <Field name="name"
                           label="組織名"
                           err={errors.name}
                           component={renderTextField}
                           type="text"/>

                    :
                    <Field disabled
                           name="name"
                           label="組織名"
                           component={renderTextField}
                           type="text"/>
                }


                <Field name="email"
                       label="メールアドレス"
                       err={errors.email}
                       component={renderTextField}
                       type="text"/>

                <Field name="address"
                       label="所在地"
                       err={errors.address}
                       component={renderTextField}
                       type="text"/>

                <Field name="capital"
                       label="資本金"
                       err={errors.capital}
                       component={renderTextField}
                       type="number"/>

                <Field name="tel"
                       label="電話番号"
                       err={errors.tel}
                       component={renderTextField}
                       type="text"/>

                <Field name="fax"
                       label="FAX番号"
                       err={errors.fax}
                       component={renderTextField}
                       type="text"/>

                <Field name="contents"
                       multiline
                       rows={1}
                       rowsMax={5}
                       label="事業内容"
                       err={errors.contents}
                       component={renderTextField}
                       type="text"/>

                <Field name="send_report"
                       label="メールアドレス宛に月末レポートを送信する"
                       err={errors.send_report}
                       component={renderCheckboxField}/>

            </form>
        )
    }
}

CompanyForm = reduxForm({
    form: 'company'
})(CompanyForm);


// WEBPACK FOOTER //
// ./src/forms/company.js